module.exports = __webpack_public_path__ + "img/gntech_main0.2a427668.jpg";